import { useState, useEffect } from 'react';

import useAuthenticatedAPIServiceCall from '@frolight/hooks/useAuthenticatedAPIServiceCall';
import * as organisationService from '@frolight/services/api/organisationService';

const useCreateOrganisation = ( organisationName, accessToken ) => {

  const [ loading, setLoading ] = useState(false);
  const [ data, setData ] = useState(null);
  const [ error, setError ] = useState(null);

  const authenticatedAPIServiceCall = useAuthenticatedAPIServiceCall();

  useEffect(() => {
    let mounted = true;

    const abortController = new AbortController();

    const runEffect = async () => {
      if (mounted) setLoading(true);
      try {
        const organisationCreationResponse = await authenticatedAPIServiceCall(
          organisationService.createOrganisation,
          {
            abortController: abortController,
            opts: {
              organisationName: organisationName
            }
          }
        );
        if (mounted) setData(organisationCreationResponse.data);
      } catch (err) {
        if (mounted) {
          if (err.name !== 'AbortError') {
            setError(err);
          }
        }
      } finally {
        if (mounted) setLoading(false);
      }
    };

    if (organisationName && accessToken) {
      runEffect();
    }

    return () => {
      mounted = false;
      abortController.abort();
    }
  }, [ organisationName, accessToken ]);

  return { loading, error, data };
};

export default useCreateOrganisation;